module.exports = __webpack_public_path__ + "media/images/presta-838e5976bd8a4499c263b875fd73a220.jpg";